import { takeEvery } from 'redux-saga/effects';
import {
  CREATE_EXPORT_TASK,
  DELETE_FILE, DOWNLOAD_EXPORT_RESULT, GET_EXPORT_AVAILABLE_COLUMNS, GET_EXPORT_TASK_STATUS,
  LOAD_CADES_STORE,
  LOAD_FILE_BY_URL,
  LOAD_STATUS,
  NORMALIZE_ADDRESS,
  SET_LOCALE,
  SIGN_DOCUMENT, SIGN_DOCX, SIGN_PDF,
  UPLOAD_FILE,
  UPLOAD_SIGN_FILE,
  UPLOAD_UNSIGNED_FILE,
} from '../actions';
import { AUTHORIZED_MODULE, SYSTEM_MODULE } from '../../../configs/moduleNames';
import { AUTHORIZED_CHECK } from '../../Authorized/actions';
import { SUCCESSFUL } from '../../../configs/actionNames';

import setLocale from './setLocale';
import loadStatus from './loadStatus';
import loadCadesStore from './loadCadesStore';
import signDocument from './signDocument';
import uploadFile from './uploadFile';
import uploadSignFile from './uploadSignFile';
import loadFileByUrl from './loadFileByUrl';
import deleteFile from './deleteFile';
import uploadUnsignedFile from './uploadUnsignedFile';
import createExportTask from './createExportTask';
import downloadExportResult from './downloadExportResult';
import getExportAvailableColumns from './getExportAvailableColumns';
import getExportTaskStatus from './getExportTaskStatus';
import signPDF from './signPDF';
import signDocx from './signDocx';
import normalizeAddress from './normalizeAddress';

export default function* watchSystem() {
  yield takeEvery(SYSTEM_MODULE + SET_LOCALE, setLocale);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL, loadStatus);
  yield takeEvery(SYSTEM_MODULE + LOAD_STATUS, loadStatus);
  yield takeEvery(LOAD_CADES_STORE, loadCadesStore);
  yield takeEvery(SYSTEM_MODULE + SIGN_DOCUMENT, signDocument);
  yield takeEvery(SYSTEM_MODULE + SIGN_PDF, signPDF);
  yield takeEvery(SYSTEM_MODULE + SIGN_DOCX, signDocx);
  yield takeEvery(SYSTEM_MODULE + UPLOAD_FILE, uploadFile);
  yield takeEvery(SYSTEM_MODULE + DELETE_FILE, deleteFile);
  yield takeEvery(SYSTEM_MODULE + UPLOAD_SIGN_FILE, uploadSignFile);
  yield takeEvery(SYSTEM_MODULE + UPLOAD_UNSIGNED_FILE, uploadUnsignedFile);
  yield takeEvery(SYSTEM_MODULE + LOAD_FILE_BY_URL, loadFileByUrl);
  yield takeEvery(SYSTEM_MODULE + CREATE_EXPORT_TASK, createExportTask);
  yield takeEvery(SYSTEM_MODULE + DOWNLOAD_EXPORT_RESULT, downloadExportResult);
  yield takeEvery(SYSTEM_MODULE + GET_EXPORT_TASK_STATUS, getExportTaskStatus);
  yield takeEvery(SYSTEM_MODULE + GET_EXPORT_AVAILABLE_COLUMNS, getExportAvailableColumns);
  yield takeEvery(SYSTEM_MODULE + NORMALIZE_ADDRESS, normalizeAddress);
}
